import { useCallback } from 'react'

import useThreeDModelUploader from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/Hooks/useThreeDModelUploader'

/**
 * The picker's two upload entry points - the first grid tile and the empty state button -
 * share the hidden file input and the "step aside once a file is chosen" behaviour.
 * `useThreeDModelEntryPoint` cannot be reused here: on the picker flag it opens this very
 * modal, so the picker has to drive the uploader directly.
 */
export default function usePickerUpload(onUploadStart) {
  const { acceptedExtensions, inputRef, isLoading, onFileChange, onFileClick } = useThreeDModelUploader()

  // The uploader takes over the viewer from here (banner, sidebar, notifications), so
  // the picker steps aside as soon as a file is chosen. A cancelled file dialog never
  // fires change, and so never closes the modal.
  const handleFileChange = useCallback((e) => {
    onFileChange(e)
    onUploadStart()
  }, [onFileChange, onUploadStart])

  return {
    accept: acceptedExtensions.map(ext => `.${ext}`).join(','),
    inputRef,
    isLoading,
    onFileChange: handleFileChange,
    onFileClick,
  }
}
